import React from 'react';
import { Link } from 'react-router-dom';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Table, Divider, message } from 'antd';
import { Api } from '../../../lib/api';

import '../styles.scss';
import { EXCEL_LABELS } from '../components/pageNameConstants';
import DeleteWarningModal from '../components/DeleteWarningModal';

interface ExcelLabelState {
    excelLabels: string[];
    loading: boolean;
    showDeleteModal: boolean;
    currentRecordName?: any;
}

interface ExcelLabelProps {}

export default class ExcelLabel extends React.PureComponent<ExcelLabelProps, ExcelLabelState> {
    state: ExcelLabelState = {
        excelLabels: [],
        loading: true,
        showDeleteModal: false,
    };

    componentDidMount() {
        this.getExcelLabels();
    }

    getExcelLabels = async () => {
        await Api.getExcelLabels().then((excelLabels) => {
            this.setState({ excelLabels: excelLabels, loading: false });
        });
    }

    deleteExcelLabels = (id: string) => {
        return Api.deleteExcelLabel(id);
    }

    import = () => {
        let input = document.createElement('input');
        input.type = 'file';
        input.setAttribute('multiple', '');

        input.addEventListener('change', async (event) => {
            if (input.files) {
                for (let i = 0; i < input.files.length; i++) {
                    await this.importFile(input.files[i]);
                }
            }
        });

        input.click();
    }

    closeDeleteModal = () => {
        this.setState({showDeleteModal: false});
    }

    async importFile(file: File) {
        const formData = new FormData();

        formData.append('filetoupload', file, file.name);

        try {
            const response = await fetch('http://' + window.location.hostname + ':8083/api/labels/upload-xlsx', {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                message.success(`File uploaded successfully`);

                setTimeout(() => this.getExcelLabels(), 1000);
            } else {
                const errorText = await response.text();

                console.error("Server error:", errorText);
                message.error(`File (${file.name}) upload failed: ${errorText}`);
            }
        } catch (error) {
            console.error("Upload failed", error);
            message.error(`File (${file.name}) upload failed: ${error}`);
        }
    };

    render() {
        return (
            <div className="section page-card">
                <div className="create-button">
                <Link to="/files/Default_Label.xlsx" target="_blank" download>
                    <Button type="primary" shape="round" icon={<DownloadOutlined />}>
                        Default Label
                    </Button>
                </Link>
                &nbsp; &nbsp;
                <Button icon={<UploadOutlined />} onClick={() => this.import()}>
                    Upload Label
                </Button>
                &nbsp; &nbsp;
                </div>
                {this.state.excelLabels && (
                    <Table
                        columns={[
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text) => <div>{text}</div>
                            },
                            {
                                title: 'Action',
                                key: 'action',
                                render: (_text, record: { name: string }) => (
                                    <div className="action-buttons">
                                        <a
                                            href={Api.getLabelDownloadUrl({
                                                excelFile: record.name
                                            })}
                                            download
                                        >
                                            <Button
                                                type="link"
                                                style={{ color: '#40a9ff' }}
                                            >
                                                Download
                                            </Button>
                                        </a>
                                        <Divider type="vertical" />
                                        <Button
                                            type="link"
                                            style={{ color: '#e60013' }}
                                            onClick={() => {
                                                this.setState({
                                                    showDeleteModal: true,
                                                    currentRecordName: record.name
                                                })
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    </div>
                                )
                            }
                        ]}
                        dataSource={this.state.excelLabels.map(name => ({ name }))}
                        pagination={{ pageSize: 8 }}
                        rowKey="name"
                        loading={this.state.loading}
                    />
                )}
                <DeleteWarningModal
                    isOpen={this.state.showDeleteModal}
                    itemTypeToDelete={EXCEL_LABELS}
                    itemNameToDelete={this.state.currentRecordName || ''}
                    closeCallback={this.closeDeleteModal}
                    update={this.getExcelLabels}
                    delete={() => this.deleteExcelLabels(this.state.currentRecordName!)}
                >
                </DeleteWarningModal>
            </div>
        );
    }
}
